import * as THREE from 'three';
import { WebGLRenderer, Mesh, SphereGeometry, MeshBasicMaterial, BoxGeometry, CylinderGeometry } from 'three';
import { MyGPU } from './MyGPU';
import { MyWaveMesh } from './MyWaveMesh';
import simplexNoise from "../glsl/simplexNoise.frag";
import { RttScenes } from '../rtt/RttScenes';
import { Params } from '../data/Params';

export class MyWave extends THREE.Object3D{

    gpu     :MyGPU;
    mesh    :MyWaveMesh;
    sphere      :Mesh;
    rttScenes   :RttScenes;
    constructor(){
        super();
    }

    /**
     * @param renderer 
     */
    public init(renderer:WebGLRenderer,rtt:RttScenes){

        this.rttScenes = rtt;
        let mat = new MeshBasicMaterial({color:0xffffff});
        mat.opacity=0.3;
        mat.transparent=true;

        this.sphere = new Mesh(
            new CylinderGeometry(2,2,1500,10,10),
            mat
        );
        this.sphere.rotation.set(Math.PI/2,0,0);
        //this.add(this.sphere)

        this.gpu = new MyGPU();//mygpu
        this.gpu.init();
        this.gpu.initWater(renderer);

        this.mesh = new MyWaveMesh();
        this.mesh.init();


        //this.p5Main =new p5Main();
        this.add(this.mesh.waterMesh);

    }

    public getTexture():THREE.Texture{
        let tex = this.gpu.getTex();
        //console.log(tex);
        return tex;
    }

    public setRainPos(rx:number,ry:number){

    }


    //波紋を生成0-1
    public addImpulse(x:number,y:number,amp:number,size:number){

        x = x - 0.5;//a
        y = y - 0.5;

        let amplitude = amp*(Params.random()-0.5);
        
        this.gpu.setMouseSize(size);
        this.gpu.setAmplitude(amplitude);
        
        let xx = MyGPU.BOUNDS*x;
        let yy = MyGPU.BOUNDS*y;
        this.gpu.addImpulse(xx,yy);      
        this.sphere.position.x = xx;
        this.sphere.position.y = -yy;
        this.sphere.visible=true;

    }

    public update(): void {
        
        this.gpu.update();
        this.mesh.update( 
            this.gpu.testMat.map,
            this.rttScenes.getTexture()
            //this.p5Main.getCanvasTex() 
        );

    }


}